import PropTypes from "prop-types"
import React from "react"
import { HiCheck } from "react-icons/hi"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function _Checkbox(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, checked, label, onChange } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleStateChange() {
        onChange && onChange(!checked)
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            <div onClick={handleStateChange} className="check-input">
                <HiCheck className="check-icon" />
            </div>
            <label className="check-label">{label}</label>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_Checkbox.propTypes = {
    className: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    label: PropTypes.string,
    activeColor: PropTypes.string,
    inactiveColor: PropTypes.string,
}

_Checkbox.defaultProps = {}

// ----------------------------------------------------------------------------

const Checkbox = styled(_Checkbox)`
    & {
        display: flex;
        align-items: center;
        flex-direction: row;
        .check-input {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 16px;
            height: 16px;
            border-radius: 3px;
            cursor: pointer;
            transition: all 200ms ease;
            background-color: ${({
                checked,
                theme,
                activeColor,
                inactiveColor,
            }) =>
                checked
                    ? activeColor ?? theme.colors.primary
                    : inactiveColor ?? theme.colors.dark200};

            .check-icon {
                transition: all 200ms ease;
                opacity: ${({ checked }) => (checked ? 1 : 0)};
                fill: ${({ theme }) => theme.colors.light};
            }
        }
        .check-label {
            color: ${({ theme }) => theme.colors.dark};
            display: block;
            margin-left: 10px;
        }
    }
`
// ----------------------------------------------------------------------------

export default Checkbox
